import _ from 'lodash'


import * as _config from './config'
export const config = _config